<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock v-if="titreTypePiece" :title="titreTypePiece">
        <v-form v-model="valid" ref="form">
          <BaseAlert :error="error" />
          <v-row>
            <v-col cols="12" md="10" offset="0" offset-md="1">
              <v-text-field
                v-model="typePiece.libelle"
                label="Libellé *"
                @input="resetApiErrors('libelle')"
                :error-messages="checkApiErrors('libelle')"
                :rules="libelleRules"
              ></v-text-field> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" md="10" offset="0" offset-md="1">
              <v-text-field
                v-model="typePiece.libelleCourt"
                label="Libellé court *"
                @input="resetApiErrors('libelleCourt')"
                :error-messages="checkApiErrors('libelleCourt')"
                :rules="libelleRules"
              ></v-text-field> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" md="10" offset="0" offset-md="1">
              <v-checkbox
                v-model="typePiece.commun"
                label="Commun *"
                :disabled="typePiece.id > 0 && !typePiece.modifCommunOk"
              ></v-checkbox> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" md="6" offset="0" offset-md="3">
              <div class="text-center">
                <v-btn
                  class="mx-2"
                  :disabled="!valid"
                  color="primary"
                  @click="enregistrer"
                  :loading="loading"
                >
                  <v-icon left>save</v-icon>Enregistrer
                </v-btn>
                <router-link
                  :to="{
                    name: 'gestion-typePiece',
                  }"
                  tag="v-btn"
                >
                  <v-icon title="Annuler"></v-icon>
                  Annuler</router-link
                >
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiTypePieceRepository from "@/repositories/ApiTypePieceRepository";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "FormTypePiece",
  components: { BaseBlock, BaseAlert },
  extends: BaseForm,
  props: ["idTypePiece"],

  data() {
    return {
      typePiece: {
        id: null,
        libelle: "",
        libelleCourt: "",
        commun: true,
      },
      libelleRules: [
        (v) =>
          (v && v.length >= 3) ||
          "Le libellé doit contenir au minimum 3 caractères",
      ],
      loading: false,
    };
  },
  computed: {
    titreTypePiece() {
      return this.idTypePiece > 0
        ? "Édition du type de pièce id=" + this.idTypePiece
        : "Nouveau type de pièce";
    },
  },
  created() {
    if (this.idTypePiece > 0) {
      this.getTypePiece(this.idTypePiece);
    }
  },
  methods: {
    async getTypePiece(id) {
      try {
        const typePiece = await ApiTypePieceRepository.getBOTypePiece(id);
        this.typePiece = typePiece;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async enregistrer() {
      this.loading = true;
      try {
        if (this.idTypePiece > 0) {
          const typePiece = await ApiTypePieceRepository.updateTypePiece(
            this.idTypePiece,
            this.typePiece
          );
          if (this.typePiece.commun != typePiece.commun) {
            this.$toast.error(
              "Caractère commun non modifié : une pièce jointe est déjà de ce type"
            );
          } else {
            this.$toast.success("Type pièce modifié");
          }
        } else {
          await ApiTypePieceRepository.addTypePiece(this.typePiece);
          this.$toast.success("Type pièce ajouté");
        }
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loading = false;
        this.$router.push({ name: "gestion-typePiece" });
      }
    },
  },
};
</script>
